import { render, staticRenderFns } from "./DetailLockHome.vue?vue&type=template&id=60deba1b&scoped=true"
import script from "./DetailLockHome.vue?vue&type=script&lang=js"
export * from "./DetailLockHome.vue?vue&type=script&lang=js"
import style0 from "./DetailLockHome.vue?vue&type=style&index=0&id=60deba1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60deba1b",
  null
  
)

export default component.exports